import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { isString } from '@dateam/ark';
import { usePreNavigationNotifier, useNavigationNotifier } from './useNavigationEvents';
import useRouter from './useRouter';
import useHistory from './useNavigationHistory';
import useRouterRegistration from './useRouterRegistration';
export default function useNavigation() {
  var _useRouterRegistratio = useRouterRegistration(),
    _useRouterRegistratio2 = _slicedToArray(_useRouterRegistratio, 1),
    router = _useRouterRegistratio2[0];
  var _useHistory = useHistory(),
    previous = _useHistory.previous,
    current = _useHistory.current,
    replaceHistory = _useHistory.replace,
    goToHistory = _useHistory.goTo,
    setPendingHistory = _useHistory.setPending;
  var _useRouter = useRouter(),
    push = _useRouter.push,
    replace = _useRouter.replace,
    pathname = _useRouter.pathname,
    query = _useRouter.query,
    location = _useRouter.location;
  var preNavNotifier = usePreNavigationNotifier();
  var navNotifier = useNavigationNotifier();
  var triggerNavigation = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(route, navAction) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!route.compareRoute(current)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return preNavNotifier(route);
          case 5:
            _context.next = 7;
            return navNotifier(route);
          case 7:
            navAction();
            _context.next = 12;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [preNavNotifier, navNotifier, current]);
  var pushFn = React.useCallback(function (route) {
    return router && triggerNavigation(route, function () {
      setPendingHistory(route);
      var path = route.toPath(router);
      if (isString(path)) push(path);
    });
  }, [router, triggerNavigation, setPendingHistory, push]);
  var replaceFn = React.useCallback(function (route) {
    return router && triggerNavigation(route, function () {
      replaceHistory(route);
      var path = route.toPath(router);
      if (isString(path)) replace(path);
    });
  }, [router, triggerNavigation, replaceHistory, replace]);
  var navigateBackFn = React.useCallback(function () {
    return previous && triggerNavigation(previous, function () {
      goToHistory(previous);
      push(-1);
    });
  }, [previous, triggerNavigation, goToHistory, push]);
  var navigation = React.useMemo(function () {
    return {
      push: pushFn,
      replace: replaceFn,
      navigateBack: navigateBackFn,
      pathname: pathname,
      query: query,
      location: location
    };
  }, [pushFn, replaceFn, navigateBackFn, pathname, query, location]);
  if (!router) throw new Error('useNavigation: no registered router has been found.');
  return navigation;
}